import { Component, Input, ElementRef} from '@angular/core';
import { NavController } from 'ionic-angular';

import { PaymentMethodHandler } from '../../providers/payment-method-handler';
import { PaymentMethodManagementPage } from '../../pages/payment-method-management/payment-method-management';

declare var Card: any;
declare var Payment: any;
declare var $;

@Component({
  selector: 'credit-card',
  templateUrl: 'credit-card.html'
})
export class CreditCardComponent {
	@Input('paymentMethod') paymentMethod;
	initialized = false;
	cardNameByIndex: any;

	cardClass: any = "credit-card";
	formClass: any = "credit-card-form";

	constructor(
		public navCtrl: NavController, 
		private elRef: ElementRef,
		public paymentMethodHandler: PaymentMethodHandler
		) {		
	}

	ngOnInit() {
		let index = this.paymentMethodHandler.getCardIndex(this.paymentMethod.number);

		this.cardClass = this.cardClass + "-" + index;		
		this.formClass = this.formClass + "-" + index;		
	}  	

	ngAfterViewInit(){
		this.initCard()  
	}

	initCard() {
		let card = new Card({
		    form: "." + this.formClass,
		    container: "." + this.cardClass,

		    placeholders: {
		        number: this.paymentMethod.number,
		        name: this.paymentMethod.name,
		        expiry: this.paymentMethod.expiry,
		        cvc: this.paymentMethod.cvc
		    }
		});

		if(this.paymentMethod.number){
			this.paymentMethodHandler	
				.setCardType(this.elRef.nativeElement, this.paymentMethod.number);			
		}	

		this.initialized = true;
	}

	manageMethod($e, method){
	    this.navCtrl.push(PaymentMethodManagementPage, {
	      method: method
	    });				
	}
}



// WEBPACK FOOTER //
// ./src/components/credit-card/credit-card.ts